import { render } from "./App.vue?vue&type=template&id=30893106"
const script = {}

import "./App.vue?vue&type=style&index=0&id=30893106&lang=scss"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__